export const CATCHES_PER_REQUEST = 8;
export const CATCHES_PER_REQUEST_FREE = 3;
export const ZOOM_IN_LIMIT = 13.8;
export const ZOOM_OUT_LIMIT = 8;
